import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';

@Component({
	selector: 'app-create-appointment',
	templateUrl: './create-appointment.component.html',
	styleUrl: './create-appointment.component.css'
})
export class CreateAppointmentComponent implements OnInit {
	breadcrumbList: any[] = [];
	uId: any = null;
	showForm = false;
	pagetitle = "Create Appointment";
	mailsParam: any;
	mailboxReadonly = true;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		if (localStorage.getItem('usertype') == "Company") {
			this.mailboxReadonly = true;
		} else {
			this.mailboxReadonly = false;
		}
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.activeRoute.queryParams.subscribe(params => {
				this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
				this.breadcrumbList = [
					{
						path: this.apiService.getHomeURL(),
						name: "Home"
					}
				];
				if (this.uId) {
					this.pagetitle = "Edit Appointment";
					this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List" });
					this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
					this.breadcrumbList.push({ path: "/app/edit-appointment/" + this.uId, name: this.pagetitle });
				} else {
					if (params["mails"]) {
						this.mailsParam = params["mails"];
						this.breadcrumbList.push({ path: "/app/mailbox/folder/unlinked", name: "Mailbox" });
						this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List", params: { mails: this.mailsParam } });
						this.breadcrumbList.push({ path: "/app/create-appointment", name: this.pagetitle, params: { mails: this.mailsParam } });
					} else {
						this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List" });
						this.breadcrumbList.push({ path: "/app/create-appointment", name: this.pagetitle });
					}
				}
				this.showForm = true;
			});
		})
	}

	onSave(Id: any) {
		this.router.navigate(['/app/appt-details', 'no', Id, "empty"]);
	}

	onCleared() {
		this.router.navigate(['/app/list-appointment']);
	}
}
